// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_eKN","cls2":"Configuration-cls2_zbx Configuration-cls1_eKN"};